import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\easyclawmart-pro\\src\\components\\blocks\\blog-detail\\index.tsx");
